export default "__VITE_ASSET__D9kW1hVs__"